import { render, staticRenderFns } from "./SuggestMember.vue?vue&type=template&id=735c42d2&scoped=true&"
import script from "./SuggestMember.vue?vue&type=script&lang=ts&"
export * from "./SuggestMember.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestMember.vue?vue&type=style&index=0&id=735c42d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c42d2",
  null
  
)

export default component.exports